module.exports = __webpack_public_path__ + "static/media/certificate.51bd6e8e.svg";